export default __webpack_public_path__ + "static/media/veth.987120c2.png";